const translations = {
  "en": {
    "Close": "Close",
    "Confirm": "Confirm",
    "CSV export": "CSV export",
    "Drop in whatever you've got — statements, holdings, an advisor's proposal. It stays private, and I'll make sense of it.": "Drop in whatever you've got — statements, holdings, an advisor's proposal. It stays private, and I'll make sense of it.",
    "From your broker app, positions visible": "From your broker app, positions visible",
    "Go back": "Go back",
    "Holdings screenshot": "Holdings screenshot",
    "Monthly or quarterly, last 90 days": "Monthly or quarterly, last 90 days",
    "Positions or transactions export": "Positions or transactions export",
    "Statement PDF": "Statement PDF",
    "Upload documents": "Upload documents",
    "Upload materials": "Upload materials",
    "Upload what you have": "Upload what you have",
    "What I can read": "What I can read",
    "Your documents": "Your documents"
  },
  "zh-tw": {
    "Close": "關閉",
    "Confirm": "確認",
    "CSV export": "CSV 匯出",
    "Drop in whatever you've got — statements, holdings, an advisor's proposal. It stays private, and I'll make sense of it.": "提供你手頭的任何資料——對帳單、持倉明細或顧問建議書。內容將嚴格保密，我將為你梳理並釐清。",
    "From your broker app, positions visible": "從你的經紀商應用程式，持倉可見",
    "Go back": "返回",
    "Holdings screenshot": "持倉截圖",
    "Monthly or quarterly, last 90 days": "每月或每季，過去 90 天",
    "Positions or transactions export": "部位或交易紀錄匯出",
    "Statement PDF": "對帳單 PDF",
    "Upload documents": "上傳檔案",
    "Upload materials": "上傳檔案",
    "Upload what you have": "上傳現有內容",
    "What I can read": "我能閱讀的內容",
    "Your documents": "你的文件"
  }
};

export default translations;
